import { jsx as t, jsxs as b, Fragment as ce } from "react/jsx-runtime";
import * as a from "react";
import ft, { useEffect as ue, useMemo as A, memo as Z, useState as Le, useCallback as O, createContext as to, useContext as oo, useRef as we } from "react";
import { Row as oe, Col as V, Select as Re, Cascader as no, Popover as pt, Drawer as io, notification as ro, Form as re, Collapse as lo, Tabs as so } from "antd";
import { u as S } from "./styled-components.browser.esm-BFmoFexH.js";
import { l as M } from "./lodash-DeBCDn4U.js";
import { FlexMetricOptionRow as mt, IconContainer as P, ContentCol as co, DeleteContainer as ao, TooltipContainer as ho, TooltipAlias as fo, TooltipContentElement as gt, MdView as po, concatInformationLinkToText as mo, ValueDescription as go, getIndexFromID as K, TooltipPopover as Qe, withSortableElement as uo, PasteButton as wo, CopyDuplicate as Co, SortableContainerContext as Tt, SortableOverlay as Ot, SortableItem as Pt, getIdFromIndex as me, WrapperItem as xo, SelectSelector as ut, WrapperRoot as Fe, isEmpty as wt, notEmpty as yo } from "@biron-data/react-components";
import { consolidateUniversalConfFilterToMetric as vo } from "./selector/filters/MetricFilterSelector/MetricFilterSelector.utils.js";
import bo from "./selector/filters/FilterPopover.js";
import { j as Ct, w as ko, d as J, P as Eo, k as Xe, W as Dt, S as ye, m as Ee, r as Ge, q as qe, a as xt, n as Ue, e as He, b as Y, K as Lo, t as yt, y as $o } from "./dummyModel-DGc8qBEQ.js";
import { D as So, r as Ro } from "./DimensionFilterSelector-C9uyeZC8.js";
import Fo from "./selector/comps/BoxesWrapper.js";
import { useLanguageResolver as q, useEventResolver as Je } from "@biron-data/react-contexts";
import "./useResizeDetector-sfyDtky2.js";
import Ao from "./description/DimensionDescription.js";
import { useHasGrowthApplied as Ke, useHasFilterApplied as Me, useHasPeriodApplied as et, useHasDisplayOptionApplied as Ht } from "./metricDisplay/MetricDisplay.hooks.js";
import "dayjs";
import { t as $e, T as se, F as Bt, P as To } from "./PeriodSelector-D59e8gvO.js";
import { v as Oo, h as vt, a as Po, l as Do, o as Ho, r as Bo, n as zo } from "./index-e062cb03-BJ_Yd14E.js";
import { F as jo } from "./XCircleIcon-C46OdWM6.js";
import "./description/ViewDescription.js";
import "./FormFooter.js";
import "./metricDetails/MetricDetails.js";
import "./metricDisplay/MetricDisplay.js";
import "./selector/comps/box/Box.js";
import "./selector/comps/box/FilterInputs.js";
import "./selector/comps/box/FilterTypeDescription.js";
import "./selector/comps/box/FilterTypeDropDown.js";
import "./selector/comps/box/inputs/FilterPattern.js";
import "./selector/comps/box/inputs/FilterRange.js";
import "./selector/comps/box/inputs/FilterScalar.js";
import "./selector/comps/box/inputs/FilterValueMatch.js";
import "./selector/comps/box/inputs/SuffixPrefixWrapper.js";
import { i as No, m as Zo } from "./utils-Mz58x57M.js";
import "./selector/comps/BoxesWrapperWithResume.js";
import "./selector/comps/boxWithDescription/BoxWithDescription.js";
import "./selector/filters/addFilterPanel/MultipleSelectWithOptionList.js";
import "./selector/filters/addFilterPanel/OptionList.js";
import "./selector/limits/LimitsSelector.js";
import "./selector/limits/SingleLimitSelector.js";
import _o from "./selector/metrics/display/MetricDisplayResume.js";
import Wo from "./selector/metrics/display/MetricFiltersResume.js";
import Io from "./selector/metrics/display/MetricPeriodResume.js";
import { ColWithLeftPadding as he } from "./selector/utils.js";
import { useGridLayout as ae, useColumnLayout as bt, useIsAxisOptionAllowed as Go, useAddSecondaryAxisOption as qo, useModifiedSecondaryAxisOption as Uo, useDefaultGrowth as Yo } from "./selector/metrics/hooks.js";
import { getAvailableDimensions as Vo } from "./configuration/useRequirements.js";
import { useSelectorLayout as U } from "./layout/useSelectorLayout.js";
import { buildMetricLabel as Ye, getGrowthLabel as Qo } from "./configuration/utils.js";
import tt from "./selector/metrics/options/selectors/CustomDisplaySelector.js";
import { MetricOptionContainer as Ae, MetricOptionContainerRow as Te } from "./selector/metrics/options/selectors/MetricOptionContainerRow.js";
import Xo from "./selector/metrics/options/selectors/ActionSelector.js";
import Jo from "./selector/metrics/options/selectors/TypeSelector.js";
import Ko from "./selector/metrics/options/selectors/PeriodSelector.js";
import Mo from "./selector/metrics/options/selectors/GrowthInvertSelector.js";
import en from "./selector/metrics/options/selectors/DecimalsSelector.js";
import tn from "./selector/metrics/options/selectors/DetailsSelector.js";
import on from "./selector/metrics/options/selectors/IntervalSelector.js";
import nn from "./selector/metrics/options/selectors/ColorSelector.js";
import { b as rn } from "./GradientSelector.utils-DUau0PhO.js";
import { useOnValuesChanges as ln } from "./selector/metrics/options/selectors/MetricDisplayOptionSelector.hooks.js";
import sn from "./selector/metrics/options/MetricOptionsFormFooter.js";
import "./selector/metrics/options/selectors/InputSelector.js";
import "./selector/sorts/MultipleSortSelector.js";
import "./selector/sorts/OrderBySelector.js";
import "./SortSelectorSelect-DSr3KYi4.js";
import "./selector/target/TargetSelector.js";
import { TooltipContentDimension as cn } from "./tooltipContent/TooltipContent.Dimension.js";
import "./layout/selectorLayout.js";
import "./tests/dummyModel.js";
import { useMetricOptions as an } from "./selector/filters/MetricFilterSelector/MetricFilterSelector.hooks.js";
import { n as dn, g as kt, _ as ie, o as zt, k as jt, j as hn, i as Et, h as ot } from "./raf-1AcQTkO6.js";
import { g as fn, u as pn, b as mn } from "./presets-P0FA1xhk.js";
import { useHandleAddMetricFromClipboard as gn } from "./hooks/useHandleAddMetricFromClipboard.js";
const un = (e, o) => Ct(e).map((i) => ({
  label: i.alias,
  value: i.code,
  description: i.description,
  type: "dimension"
})).sortBy("label").value().concat(Ct(o).map((i) => ({
  label: i.alias,
  value: i.code,
  description: i.description,
  disabled: !0,
  type: "dimension"
})).sortBy("label").value()), Nt = (e, o, i) => {
  ue(
    () => {
      o !== i && i && (e == null || e(i));
    },
    [e, o, i]
  );
}, Oe = (e, o) => A(() => e && typeof e == "object" ? Object.assign([], Object.entries(e)).map(([i, n]) => {
  const h = o ? o.filter((c) => c.field === i).map((c) => c.message) : [];
  return {
    name: [i],
    errors: h,
    value: n
  };
}) : [], [e, o]), wn = (e) => {
  const o = $e(e.start).startOf("day");
  return $e(e.end).endOf("day").diff(o, "day") + 1;
}, nt = (e) => A(() => wn(e), [e]), Zt = (e, o, i, n) => {
  const h = Cn(e);
  return {
    start: $e(i.start).subtract(o ?? n, h).startOf("day"),
    end: $e(i.end).subtract(o ?? n, h).endOf("day")
  };
}, _t = ({ start: e, end: o }, i = "dd DD MMM YYYY") => `${e.format(i)} - ${o.format(i)}`, Cn = (e) => {
  switch (e) {
    case se.DAY:
      return "day";
    case se.WEEK:
      return "week";
    case se.MONTH:
      return "month";
    case se.QUARTER:
      return "quarter";
    case se.YEAR:
      return "year";
    default:
      return e;
  }
}, xn = (e) => /* @__PURE__ */ a.createElement("svg", { width: 22, height: 22, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ a.createElement("rect", { x: 1, y: 1, width: 20, height: 20, rx: 3, fill: "#92A1E9" }), /* @__PURE__ */ a.createElement("rect", { x: 1, y: 1, width: 20, height: 20, rx: 3, stroke: "#92A1E9", strokeWidth: 2 }), /* @__PURE__ */ a.createElement("path", { d: "M11.556 8H16m0 0v4.8M16 8l-4.444 4.8-2.223-2.4L6 14", stroke: "#1B1B1D", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), yn = (e) => /* @__PURE__ */ a.createElement("svg", { width: 22, height: 22, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ a.createElement("rect", { x: 1, y: 1, width: 20, height: 20, rx: 3, fill: "#92A1E9" }), /* @__PURE__ */ a.createElement("rect", { x: 1, y: 1, width: 20, height: 20, rx: 3, stroke: "#92A1E9", strokeWidth: 2 }), /* @__PURE__ */ a.createElement("path", { d: "M16.25 5.75a.875.875 0 0 0-.875-.875h-8.75a.875.875 0 0 0-.875.875v1.9c0 .464.184.91.513 1.238l2.474 2.474c.329.329.513.774.513 1.238v3.817c0 .325.342.537.633.391l1.9-.95a1.75 1.75 0 0 0 .967-1.565V12.6c0-.464.184-.91.513-1.238l2.474-2.474a1.75 1.75 0 0 0 .513-1.238v-1.9Z", fill: "#1B1B1D" })), vn = (e) => /* @__PURE__ */ a.createElement("svg", { width: 22, height: 22, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ a.createElement("rect", { x: 1, y: 1, width: 20, height: 20, rx: 3, fill: "#92A1E9" }), /* @__PURE__ */ a.createElement("rect", { x: 1, y: 1, width: 20, height: 20, rx: 3, stroke: "#92A1E9", strokeWidth: 2 }), /* @__PURE__ */ a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 4.75a.75.75 0 0 1 1.5 0V6h5V4.75a.75.75 0 0 1 1.5 0V6a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2V4.75ZM7.5 9a1 1 0 0 0-1 1v4.5a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1h-7Z", fill: "#1B1B1D" })), bn = (e) => /* @__PURE__ */ a.createElement("svg", { width: 22, height: 22, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ a.createElement("rect", { x: 1, y: 1, width: 20, height: 20, rx: 3, fill: "#92A1E9" }), /* @__PURE__ */ a.createElement("rect", { x: 1, y: 1, width: 20, height: 20, rx: 3, stroke: "#92A1E9", strokeWidth: 2 }), /* @__PURE__ */ a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 7.25A2.25 2.25 0 0 1 7.25 5h7.5A2.25 2.25 0 0 1 17 7.25v5.5A2.25 2.25 0 0 1 14.75 15h-1.312c.1.128.21.248.328.36a.75.75 0 0 1 .234.545v.345a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1-.75-.75v-.345a.75.75 0 0 1 .234-.545c.118-.111.228-.232.328-.36H7.25A2.25 2.25 0 0 1 5 12.75v-5.5Zm2.25-.75a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75h7.5a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 0 0-.75-.75h-7.5Z", fill: "#1B1B1D" })), kn = (e) => /* @__PURE__ */ a.createElement("svg", { width: 22, height: 22, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ a.createElement("rect", { x: 1, y: 1, width: 20, height: 20, rx: 3, fill: "#EAB79E" }), /* @__PURE__ */ a.createElement("rect", { x: 1, y: 1, width: 20, height: 20, rx: 3, stroke: "#EAB79E", strokeWidth: 2 }), /* @__PURE__ */ a.createElement("path", { d: "m14.107 9.588-.518 2.422h1.848v1.4h-2.141l-.56 2.59h-1.527l.56-2.59H9.027L8.466 16H6.94l.56-2.59H5.33v-1.4h2.464l.518-2.422H6.156v-1.4h2.45l.546-2.548h1.526l-.546 2.548h2.744l.546-2.548h1.525l-.545 2.548h1.862v1.4h-2.156Zm-1.525 0H9.838L9.32 12.01h2.743l.518-2.422Z", fill: "#1B1B1D" })), En = (e) => /* @__PURE__ */ a.createElement("svg", { width: 22, height: 22, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ a.createElement("rect", { x: 1, y: 1, width: 20, height: 20, rx: 3, fill: "#92A1E9" }), /* @__PURE__ */ a.createElement("rect", { x: 1, y: 1, width: 20, height: 20, rx: 3, stroke: "#92A1E9", strokeWidth: 2 }), /* @__PURE__ */ a.createElement("path", { d: "m14.107 9.588-.518 2.422h1.848v1.4h-2.141l-.56 2.59h-1.527l.56-2.59H9.027L8.466 16H6.94l.56-2.59H5.33v-1.4h2.464l.518-2.422H6.156v-1.4h2.45l.546-2.548h1.526l-.546 2.548h2.744l.546-2.548h1.525l-.545 2.548h1.862v1.4h-2.156Zm-1.525 0H9.838L9.32 12.01h2.743l.518-2.422Z", fill: "#1B1B1D" })), Ln = (e) => /* @__PURE__ */ a.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M8 16H6C4.89543 16 4 15.1046 4 14V6C4 4.89543 4.89543 4 6 4H14C15.1046 4 16 4.89543 16 6V8M10 20H18C19.1046 20 20 19.1046 20 18V10C20 8.89543 19.1046 8 18 8H10C8.89543 8 8 8.89543 8 10V18C8 19.1046 8.89543 20 10 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ a.createElement("rect", { x: 8.677, y: 8.24854, width: 11.323, height: 11.7515, fill: "currentColor" })), $n = (e) => /* @__PURE__ */ a.createElement("svg", { width: 22, height: 22, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ a.createElement("rect", { x: 1, y: 1, width: 20, height: 20, rx: 3, fill: "#92A1E9" }), /* @__PURE__ */ a.createElement("rect", { x: 1, y: 1, width: 20, height: 20, rx: 3, stroke: "#92A1E9", strokeWidth: 2 }), /* @__PURE__ */ a.createElement("path", { d: "M5.903 8.575c0-.684.198-1.22.594-1.606.405-.388.923-.581 1.553-.581.63 0 1.143.194 1.539.58.405.388.607.923.607 1.607 0 .693-.202 1.233-.607 1.62-.396.387-.91.58-1.54.58s-1.147-.193-1.552-.58c-.396-.387-.594-.927-.594-1.62ZM14.57 6.55 9.265 16H7.429l5.292-9.45h1.85Zm-6.534.972c-.495 0-.742.351-.742 1.053 0 .711.247 1.067.742 1.067.243 0 .432-.086.567-.257.135-.18.203-.45.203-.81 0-.702-.257-1.053-.77-1.053Zm3.794 6.44c0-.694.198-1.229.594-1.607.405-.387.922-.58 1.552-.58s1.139.193 1.526.58c.396.378.594.913.594 1.606 0 .694-.198 1.233-.594 1.62-.387.388-.896.581-1.526.581-.639 0-1.156-.193-1.552-.58-.396-.388-.594-.928-.594-1.62Zm2.133-1.053c-.513 0-.77.35-.77 1.052 0 .711.257 1.067.77 1.067.504 0 .756-.356.756-1.067 0-.702-.252-1.053-.756-1.053Z", fill: "#1B1B1D" })), Sn = (e) => /* @__PURE__ */ a.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM8.28033 7.21967C7.98744 6.92678 7.51256 6.92678 7.21967 7.21967C6.92678 7.51256 6.92678 7.98744 7.21967 8.28033L8.93934 10L7.21967 11.7197C6.92678 12.0126 6.92678 12.4874 7.21967 12.7803C7.51256 13.0732 7.98744 13.0732 8.28033 12.7803L10 11.0607L11.7197 12.7803C12.0126 13.0732 12.4874 13.0732 12.7803 12.7803C13.0732 12.4874 13.0732 12.0126 12.7803 11.7197L11.0607 10L12.7803 8.28033C13.0732 7.98744 13.0732 7.51256 12.7803 7.21967C12.4874 6.92678 12.0126 6.92678 11.7197 7.21967L10 8.93934L8.28033 7.21967Z", fill: "#EE6873" })), Rn = (e) => /* @__PURE__ */ a.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM13.8566 8.19113C14.1002 7.85614 14.0261 7.38708 13.6911 7.14345C13.3561 6.89982 12.8871 6.97388 12.6434 7.30887L9.15969 12.099L7.28033 10.2197C6.98744 9.92678 6.51256 9.92678 6.21967 10.2197C5.92678 10.5126 5.92678 10.9874 6.21967 11.2803L8.71967 13.7803C8.87477 13.9354 9.08999 14.0149 9.30867 13.9977C9.52734 13.9805 9.72754 13.8685 9.85655 13.6911L13.8566 8.19113Z", fill: "#4DE59C" })), Fn = (e) => /* @__PURE__ */ a.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10ZM10 11C10.5523 11 11 10.5523 11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11ZM7 10C7 10.5523 6.55228 11 6 11C5.44772 11 5 10.5523 5 10C5 9.44772 5.44772 9 6 9C6.55228 9 7 9.44772 7 10ZM14 11C14.5523 11 15 10.5523 15 10C15 9.44772 14.5523 9 14 9C13.4477 9 13 9.44772 13 10C13 10.5523 13.4477 11 14 11Z", fill: "#F28C5A" })), An = (e) => /* @__PURE__ */ a.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2Z", fill: "#7CE0DA" }), /* @__PURE__ */ a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.7805 6.96728C12.7805 6.69114 12.5567 6.46728 12.2805 6.46728H7.71938C7.44323 6.46728 7.21938 6.69114 7.21938 6.96728C7.21938 7.23942 7.43679 7.46078 7.7074 7.46714C8.03443 8.49646 8.46528 9.10838 9.37136 9.99999C8.23663 10.8271 7.91108 11.4847 7.66929 12.5352C7.41666 12.5603 7.21938 12.7735 7.21938 13.0327C7.21938 13.3088 7.44323 13.5327 7.71938 13.5327H12.2805C12.5567 13.5327 12.7805 13.3088 12.7805 13.0327C12.7805 12.7594 12.5612 12.5372 12.2889 12.5328C11.9721 11.5 11.6469 10.839 10.6285 9.99999C11.5489 9.08784 11.9439 8.45899 12.2792 7.46728H12.2805C12.5567 7.46728 12.7805 7.24342 12.7805 6.96728Z", fill: "white" })), Tn = (e) => /* @__PURE__ */ a.createElement("svg", { width: 22, height: 22, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ a.createElement("rect", { x: 1, y: 1, width: 20, height: 20, rx: 3, fill: "#EAB79E" }), /* @__PURE__ */ a.createElement("rect", { x: 1, y: 1, width: 20, height: 20, rx: 3, stroke: "#EAB79E", strokeWidth: 2 }), /* @__PURE__ */ a.createElement("path", { d: "M8.485 14.154H4.702L4.051 16H2.505l3.237-9.048h1.715L10.694 16h-1.56l-.65-1.846Zm-.416-1.209-1.47-4.199-1.482 4.199H8.07Zm3.539-.559c0-.72.147-1.356.442-1.911a3.3 3.3 0 0 1 2.938-1.755c.563 0 1.053.113 1.469.338.425.217.763.49 1.014.819v-1.04h1.495V16h-1.495v-1.066a2.94 2.94 0 0 1-1.027.845c-.433.225-.927.338-1.482.338a3.182 3.182 0 0 1-1.69-.468 3.473 3.473 0 0 1-1.222-1.326c-.295-.572-.442-1.218-.442-1.937Zm5.863.026c0-.494-.104-.923-.312-1.287a2.1 2.1 0 0 0-.793-.832 2.092 2.092 0 0 0-1.066-.286c-.381 0-.737.095-1.066.286a2.09 2.09 0 0 0-.806.819c-.2.355-.299.78-.299 1.274s.1.927.299 1.3c.208.373.477.659.806.858a2.138 2.138 0 0 0 2.132 0 2.1 2.1 0 0 0 .793-.832c.208-.373.312-.806.312-1.3Z", fill: "#1B1B1D" })), On = (e) => /* @__PURE__ */ a.createElement("svg", { width: 22, height: 22, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ a.createElement("rect", { x: 1, y: 1, width: 20, height: 20, rx: 3, fill: "#97E3BF" }), /* @__PURE__ */ a.createElement("rect", { x: 1, y: 1, width: 20, height: 20, rx: 3, stroke: "#97E3BF", strokeWidth: 2 }), /* @__PURE__ */ a.createElement("path", { d: "M11 12.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z", fill: "#1B1B1D" }), /* @__PURE__ */ a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.38 11.28a.87.87 0 0 1 0-.566 7.003 7.003 0 0 1 13.238.005.87.87 0 0 1 0 .567 7.003 7.003 0 0 1-13.239-.005ZM14 11a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z", fill: "#1B1B1D" })), Pn = (e) => /* @__PURE__ */ a.createElement("svg", { width: 19, height: 16, viewBox: "0 0 19 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M6.791 11.012H2.717L2.017 13H0.351L3.837 3.256H5.685L9.171 13H7.491L6.791 11.012ZM6.343 9.71L4.761 5.188L3.165 9.71H6.343ZM10.1547 9.108C10.1547 8.33333 10.3134 7.64733 10.6307 7.05C10.9574 6.45267 11.3961 5.99067 11.9467 5.664C12.5067 5.328 13.1227 5.16 13.7947 5.16C14.4014 5.16 14.9287 5.28133 15.3767 5.524C15.8341 5.75733 16.1981 6.05133 16.4687 6.406V5.286H18.0787V13H16.4687V11.852C16.1981 12.216 15.8294 12.5193 15.3627 12.762C14.8961 13.0047 14.3641 13.126 13.7667 13.126C13.1041 13.126 12.4974 12.958 11.9467 12.622C11.3961 12.2767 10.9574 11.8007 10.6307 11.194C10.3134 10.578 10.1547 9.88267 10.1547 9.108ZM16.4687 9.136C16.4687 8.604 16.3567 8.142 16.1327 7.75C15.9181 7.358 15.6334 7.05933 15.2787 6.854C14.9241 6.64867 14.5414 6.546 14.1307 6.546C13.7201 6.546 13.3374 6.64867 12.9827 6.854C12.6281 7.05 12.3387 7.344 12.1147 7.736C11.9001 8.11867 11.7927 8.576 11.7927 9.108C11.7927 9.64 11.9001 10.1067 12.1147 10.508C12.3387 10.9093 12.6281 11.2173 12.9827 11.432C13.3467 11.6373 13.7294 11.74 14.1307 11.74C14.5414 11.74 14.9241 11.6373 15.2787 11.432C15.6334 11.2267 15.9181 10.928 16.1327 10.536C16.3567 10.1347 16.4687 9.668 16.4687 9.136Z" })), Dn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Case: Pn,
  Date: vn,
  Display: bn,
  Filter: yn,
  Growth: xn,
  NumericDimension: kn,
  NumericMetric: En,
  Paste: Ln,
  Ratio: $n,
  StateError: Sn,
  StateOk: Rn,
  StateOngoing: Fn,
  StateWaiting: An,
  Text: Tn,
  View: On
}, Symbol.toStringTag, { value: "Module" })), ve = (e) => /* @__PURE__ */ a.createElement("svg", { width: 14, height: 8, viewBox: "0 0 14 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M13 7H1V1", stroke: "#BEC5CC", strokeLinecap: "round", strokeLinejoin: "round" })), Hn = (e) => /* @__PURE__ */ a.createElement("svg", { width: 12, height: 12, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "w-6 h-6", ...e }, /* @__PURE__ */ a.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" }));
function Bn(e, o) {
  return /* @__PURE__ */ a.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: o
  }, e), /* @__PURE__ */ a.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2h-2.22l.123.489.804.804A1 1 0 0113 18H7a1 1 0 01-.707-1.707l.804-.804L7.22 15H5a2 2 0 01-2-2V5zm5.771 7H5V5h10v7H8.771z",
    clipRule: "evenodd"
  }));
}
const Wt = a.forwardRef(Bn);
function zn(e, o) {
  return /* @__PURE__ */ a.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: o
  }, e), /* @__PURE__ */ a.createElement("path", {
    fillRule: "evenodd",
    d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  }));
}
const Be = a.forwardRef(zn);
function jn(e, o) {
  return /* @__PURE__ */ a.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: o
  }, e), /* @__PURE__ */ a.createElement("path", {
    fillRule: "evenodd",
    d: "M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z",
    clipRule: "evenodd"
  }));
}
const It = a.forwardRef(jn);
function Nn(e, o) {
  return /* @__PURE__ */ a.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: o
  }, e), /* @__PURE__ */ a.createElement("path", {
    fillRule: "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    clipRule: "evenodd"
  }));
}
const Zn = a.forwardRef(Nn), _n = Z(({
  value: e,
  setActiveKey: o,
  onDelete: i,
  timeInterval: n,
  dayDifference: h,
  iconSize: c,
  iconSpan: s
}) => {
  var C, x, E, v, L, r, g;
  const u = q(), [m, f] = Le(!1), p = ko((C = e == null ? void 0 : e.growth) == null ? void 0 : C.period), d = Eo(o), l = U(), w = l === "compact" ? {
    gutter: 12
  } : {};
  return /* @__PURE__ */ t(Gn, { children: ((x = e == null ? void 0 : e.growth) == null ? void 0 : x.period) && ((E = e.growth) == null ? void 0 : E.type) && /* @__PURE__ */ t(qn, { children: /* @__PURE__ */ t(In, { children: /* @__PURE__ */ b(oe, { ...w, children: [
    /* @__PURE__ */ t(V, { span: s, onClick: () => o == null ? void 0 : o(J.growth), children: /* @__PURE__ */ t(mt, { $clickable: d, children: /* @__PURE__ */ t(P, { size: c, children: /* @__PURE__ */ t(Oo.Growth, {}) }) }) }),
    /* @__PURE__ */ t(co, { span: 19, onClick: () => o == null ? void 0 : o(J.growth), children: /* @__PURE__ */ b(
      mt,
      {
        $clickable: d,
        onMouseOver: () => f(!0),
        onMouseLeave: () => f(!1),
        children: [
          /* @__PURE__ */ t("span", { children: `${u.get(`growth.type-preset.${(v = e == null ? void 0 : e.growth) == null ? void 0 : v.type.toLowerCase()}`)} ${u.get(`growth.value.${p}`, (L = e.growth) == null ? void 0 : L.period.quantity)}` }),
          l !== "compact" && n && /* @__PURE__ */ t(Wn, { children: _t(
            Zt(
              (r = e.growth) == null ? void 0 : r.period.unit,
              ((g = e.growth) == null ? void 0 : g.period.quantity) ?? void 0,
              n,
              h
            ),
            "DD MMM YYYY"
          ) }),
          m && i && /* @__PURE__ */ t(ao, { children: /* @__PURE__ */ t(P, { clickable: !0, size: 14, color: "var(--light-grey)", children: /* @__PURE__ */ t(jo, { onClick: () => i(["growthLabel", "growthType", "growthPeriod", "growthInvert"]) }) }) })
        ]
      }
    ) })
  ] }) }) }) });
}), Wn = S.span`
  font-style: italic;
  font-weight: 400;
  line-height: 18px;

  color: #C6C6C6;
`, In = S.div`
  display: flex;
  flex-direction: column;
`, Gn = S.div`
  width: 100%;
  cursor: pointer;
`, qn = S.div`
  align-items: center;
  gap: 10px;
`;
function Un(e, o) {
  return /* @__PURE__ */ a.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: o
  }, e), /* @__PURE__ */ a.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
  }), /* @__PURE__ */ a.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
  }));
}
const ze = a.forwardRef(Un);
function Yn(e, o) {
  return /* @__PURE__ */ a.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: o
  }, e), /* @__PURE__ */ a.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
  }));
}
const Vn = a.forwardRef(Yn), Gt = Z(({
  value: e,
  setActiveKey: o,
  onDelete: i,
  timeInterval: n,
  dayDifference: h,
  isNameDisplayed: c = !1,
  iconSize: s = 16,
  additionnalStyle: u,
  hideDisplayOptions: m = !1,
  iconSpan: f = 1
}) => {
  const p = Ke({ growth: e == null ? void 0 : e.growth }), d = Me({ additionalFilters: (e == null ? void 0 : e.additionalFilters) ?? [] }), l = et({ overridePeriod: e == null ? void 0 : e.overridePeriod }), w = Ht({
    extraConf: e == null ? void 0 : e.extraConf
  });
  return /* @__PURE__ */ b(Xn, { $additionnalstyle: u, children: [
    c && (e == null ? void 0 : e.titlePartOverrides) && Object.values(e.titlePartOverrides).filter((C) => !M.isEmpty(C)).length > 0 && /* @__PURE__ */ t(Qn, { children: e.metricAlias }),
    p && /* @__PURE__ */ t(
      _n,
      {
        iconSpan: f,
        value: e,
        timeInterval: n,
        dayDifference: h,
        setActiveKey: o,
        iconSize: s,
        onDelete: i
      }
    ),
    l && /* @__PURE__ */ t(
      Io,
      {
        iconSpan: f,
        value: e,
        setActiveKey: o,
        iconSize: s,
        onDelete: i
      }
    ),
    d && /* @__PURE__ */ t(
      Wo,
      {
        iconSpan: f,
        value: e,
        setActiveKey: o,
        iconSize: s,
        onDelete: i
      }
    ),
    w && !m && /* @__PURE__ */ t(
      _o,
      {
        iconSpan: f,
        value: e,
        setActiveKey: o,
        iconSize: s,
        onDelete: i
      }
    )
  ] });
}), Qn = S.div`
  color: var(--medium-grey)
`, Xn = S(oe)`
    gap: 4px;
    line-height: 16px;
    * {
        font-size: 12px;
    }
    ${({ $additionnalstyle: e }) => e}
`, qt = Z(({ timeInterval: e, metric: o, getMoreInformationLink: i }) => {
  var f, p, d;
  const n = q(), h = i(o.metricCode), c = nt(e), s = Ke(o), u = Me(o), m = et(o);
  return /* @__PURE__ */ b(ho, { children: [
    /* @__PURE__ */ b(fo, { translate: "no", children: [
      /* @__PURE__ */ t(P, { size: 22, children: /* @__PURE__ */ t(vt, {}) }),
      /* @__PURE__ */ t("div", { children: o.metricAlias })
    ] }),
    /* @__PURE__ */ b(gt, { children: [
      /* @__PURE__ */ b(Lt, { children: [
        /* @__PURE__ */ t(Po, {}),
        o.viewAlias
      ] }),
      /* @__PURE__ */ b(Lt, { children: [
        /* @__PURE__ */ t(P, { size: 22, children: /* @__PURE__ */ t(vt, {}) }),
        ((f = o.metricDef) == null ? void 0 : f.alias) ?? ""
      ] }),
      !M.isEmpty((p = o.metricDef) == null ? void 0 : p.description) && /* @__PURE__ */ t(Kn, { children: /* @__PURE__ */ t(po, { description: mo((d = o.metricDef) == null ? void 0 : d.description, n, h), padding: 0 }) })
    ] }),
    (s || u || m) && /* @__PURE__ */ t(Jn, {}),
    /* @__PURE__ */ t(gt, { children: /* @__PURE__ */ t(
      Gt,
      {
        value: o,
        iconSpan: 2,
        isNameDisplayed: !1,
        timeInterval: e,
        dayDifference: c,
        additionnalStyle: "gap: 10px;",
        hideDisplayOptions: !0
      }
    ) })
  ] });
}), Jn = S.div`
    height: 0;
    border-top: 1px solid var(--light-grey);
    margin-bottom: 15px;
    width: calc(100% - 18px);
`, Kn = S.div`
    margin-bottom: 10px;
`, Lt = S.div`
    display: flex;
    align-items: center;
    gap: 15px;
    align-content: start;
    line-height: 22px;
`, Mn = Z(function({
  metric: o,
  timeInterval: i,
  getMoreInformationLink: n
}) {
  return /* @__PURE__ */ t(go, { children: /* @__PURE__ */ t(qt, { metric: o, timeInterval: i, getMoreInformationLink: n }) });
}), ei = ({ value: e, canRemove: o, onChange: i, viewsWithMetrics: n, ...h }) => {
  const c = n[0], s = U(), u = O(
    ({ label: f }) => s === "compact" ? /* @__PURE__ */ t("div", { children: f }) : f,
    [s]
  ), m = O(
    (f) => {
      i(f ? {
        metricCode: f,
        viewCode: c == null ? void 0 : c.code,
        viewAlias: c == null ? void 0 : c.alias,
        additionalFilters: [],
        titlePartOverrides: {}
      } : null);
    },
    [i, c]
  );
  return /* @__PURE__ */ t(ti, { ...h, showSearch: !0, allowClear: o, optionFilterProp: "children", value: (e == null ? void 0 : e.metricCode) ?? null, onChange: m, virtual: !1, labelRender: u, children: c == null ? void 0 : c.metrics.map(({ alias: f, code: p }) => /* @__PURE__ */ t(Re.Option, { children: f }, p)) });
}, ti = S(Re)`
    width: 100%;
`, oi = ({
  value: e,
  defaultView: o,
  placeholder: i,
  canRemove: n,
  onChange: h,
  viewsWithMetrics: c,
  unavailableViews: s,
  getPopupContainer: u
}) => {
  const m = U(), f = A(
    () => c.map((l) => ({
      value: l.code,
      label: l.alias,
      children: l.metrics.map(({ alias: w, code: C }) => ({
        value: C,
        label: w
      }))
    })).concat(s.map((l) => ({
      value: l.code,
      label: l.alias,
      disabled: !0,
      children: l.metrics.map(({ alias: w, code: C }) => ({
        value: C,
        label: w
      }))
    }))),
    [c, s]
  ), p = O(
    (l) => {
      const w = l.length === 2 ? l.join(" / ") : void 0;
      return m === "compact" ? /* @__PURE__ */ t("div", { children: w }) : w;
    },
    [m]
  ), d = O(
    (l) => {
      const w = l && l[0] ? f.find((C) => C.value === l[0]) : void 0;
      l && w && l.length > 1 && M.isString(l[1]) ? h({
        viewCode: w == null ? void 0 : w.value,
        viewAlias: w == null ? void 0 : w.label,
        metricCode: l[1],
        additionalFilters: [],
        titlePartOverrides: {}
      }) : l === void 0 && h(null);
    },
    [h, f]
  );
  return /* @__PURE__ */ t(ri, { options: f, placeholder: i, allowClear: n, showSearch: ni, value: ii(e, o) ?? [], displayRender: p, onChange: d, getPopupContainer: u, multiple: !1 });
}, ni = {
  filter: (e, o) => o.some((i) => i.label.toLocaleLowerCase().indexOf(e.toLocaleLowerCase()) > -1),
  matchInputWidth: !1
}, ii = (e, o) => e ? [e.viewCode, e.metricCode] : e && o ? [o] : void 0, ri = S(no)`
    width: 100%;
`, Se = Z(function({
  id: o,
  value: i,
  defaultView: n,
  canRemove: h,
  onChange: c,
  onDelete: s,
  groupMetricsByView: u,
  viewsWithMetrics: m,
  unavailableViews: f,
  getPopupContainer: p,
  timeInterval: d,
  getMoreInformationLink: l
}) {
  const w = q(), C = U(), x = A(() => i ? {
    ...i,
    growth: i.growth ? {
      ...i.growth,
      period: {
        ...i.growth.period,
        quantity: i.growth.period.quantity
      }
    } : void 0
  } : void 0, [i]), E = O(
    (r) => {
      r ? c == null || c(K(o), {
        ...x || {},
        ...r
      }) : s && s(K(o));
    },
    [x, c, o, s]
  ), v = `${w.get("configuration-add-metric")} ...`, L = u ? /* @__PURE__ */ t(oi, { value: x, defaultView: n, placeholder: v, canRemove: h, onChange: E, viewsWithMetrics: m, unavailableViews: f, getPopupContainer: p }) : /* @__PURE__ */ t(ei, { value: x, placeholder: v, canRemove: h, onChange: E, viewsWithMetrics: m, getPopupContainer: p });
  return x && C === "compact" && d && l ? /* @__PURE__ */ t(
    Qe,
    {
      size: "small",
      content: /* @__PURE__ */ t(
        qt,
        {
          metric: x,
          timeInterval: d,
          getMoreInformationLink: l
        }
      ),
      mouseEnterDelay: 0.4,
      children: /* @__PURE__ */ t("div", { children: L })
    }
  ) : L;
});
Se.Sortable = uo(Se);
const li = Z(({
  id: e,
  environmentId: o,
  offset: i,
  value: n,
  canInvert: h,
  canRemove: c,
  handleAdd: s,
  onDelete: u,
  groupMetricsByView: m,
  viewsWithMetrics: f,
  unavailableViews: p,
  growthDisabled: d,
  numberOfSlicer: l,
  getPopupContainer: w,
  isAxisOptionAvailable: C = !1,
  displayType: x,
  dashboardSelection: E,
  period: v,
  metaModel: L,
  copiedMetric: r,
  withPasteOptions: g
}) => {
  const F = q(), T = U(), H = Je(), B = gn(
    r,
    () => {
      r && s(r);
    }
  ), $ = ae(T, { span: 13 }, { span: 22 }), W = ae(T, { span: 10 }, { span: 1 });
  return /* @__PURE__ */ b(ce, { children: [
    /* @__PURE__ */ t(V, { ...$, offset: i, children: /* @__PURE__ */ t(
      Se,
      {
        environmentId: o,
        id: e,
        value: n,
        groupMetricsByView: m,
        viewsWithMetrics: f,
        unavailableViews: p,
        growthDisabled: d,
        canInvert: h,
        canRemove: c,
        onChange: (k, ee) => s(ee),
        onDelete: u,
        numberOfSlicer: l,
        getPopupContainer: w,
        isAxisOptionAvailable: C,
        isAxisOptionDisabled: e === 0,
        displayType: x,
        metaModel: L,
        dashboardSelection: E,
        period: v
      }
    ) }),
    g && /* @__PURE__ */ t(he, { $value: 5, style: {
      display: "flex",
      alignContent: "center",
      alignItems: "center"
    }, title: F.get("configuration-metric-options.info.paste"), ...W, children: /* @__PURE__ */ t("div", { children: /* @__PURE__ */ t(wo, { handleClick: () => {
      H.capture({
        category: "metrics",
        action: "add_metric_paste"
      }), B();
    }, style: { width: 16, height: 16, display: "flex", padding: 0 }, size: 16, Icon: Dn.Paste, type: "text" }) }) })
  ] });
});
var Ut = /* @__PURE__ */ to({});
function Yt(e) {
  var o;
  return e == null || (o = e.getRootNode) === null || o === void 0 ? void 0 : o.call(e);
}
function si(e) {
  return Yt(e) instanceof ShadowRoot;
}
function ci(e) {
  return si(e) ? Yt(e) : null;
}
function ai(e) {
  return e.replace(/-(.)/g, function(o, i) {
    return i.toUpperCase();
  });
}
function di(e, o) {
  dn(e, "[@ant-design/icons] ".concat(o));
}
function $t(e) {
  return kt(e) === "object" && typeof e.name == "string" && typeof e.theme == "string" && (kt(e.icon) === "object" || typeof e.icon == "function");
}
function St() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(e).reduce(function(o, i) {
    var n = e[i];
    switch (i) {
      case "class":
        o.className = n, delete o.class;
        break;
      default:
        delete o[i], o[ai(i)] = n;
    }
    return o;
  }, {});
}
function Ve(e, o, i) {
  return i ? /* @__PURE__ */ ft.createElement(e.tag, ie(ie({
    key: o
  }, St(e.attrs)), i), (e.children || []).map(function(n, h) {
    return Ve(n, "".concat(o, "-").concat(e.tag, "-").concat(h));
  })) : /* @__PURE__ */ ft.createElement(e.tag, ie({
    key: o
  }, St(e.attrs)), (e.children || []).map(function(n, h) {
    return Ve(n, "".concat(o, "-").concat(e.tag, "-").concat(h));
  }));
}
function Vt(e) {
  return fn(e)[0];
}
function Qt(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var hi = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, fi = function(o) {
  var i = oo(Ut), n = i.csp, h = i.prefixCls, c = hi;
  h && (c = c.replace(/anticon/g, h)), ue(function() {
    var s = o.current, u = ci(s);
    pn(c, "@ant-design-icons", {
      prepend: !0,
      csp: n,
      attachTo: u
    });
  }, []);
}, pi = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], ge = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function mi(e) {
  var o = e.primaryColor, i = e.secondaryColor;
  ge.primaryColor = o, ge.secondaryColor = i || Vt(o), ge.calculated = !!i;
}
function gi() {
  return ie({}, ge);
}
var fe = function(o) {
  var i = o.icon, n = o.className, h = o.onClick, c = o.style, s = o.primaryColor, u = o.secondaryColor, m = zt(o, pi), f = a.useRef(), p = ge;
  if (s && (p = {
    primaryColor: s,
    secondaryColor: u || Vt(s)
  }), fi(f), di($t(i), "icon should be icon definiton, but got ".concat(i)), !$t(i))
    return null;
  var d = i;
  return d && typeof d.icon == "function" && (d = ie(ie({}, d), {}, {
    icon: d.icon(p.primaryColor, p.secondaryColor)
  })), Ve(d.icon, "svg-".concat(d.name), ie(ie({
    className: n,
    onClick: h,
    style: c,
    "data-icon": d.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, m), {}, {
    ref: f
  }));
};
fe.displayName = "IconReact";
fe.getTwoToneColors = gi;
fe.setTwoToneColors = mi;
function Xt(e) {
  var o = Qt(e), i = jt(o, 2), n = i[0], h = i[1];
  return fe.setTwoToneColors({
    primaryColor: n,
    secondaryColor: h
  });
}
function ui() {
  var e = fe.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var wi = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
Xt(mn.primary);
var Ce = /* @__PURE__ */ a.forwardRef(function(e, o) {
  var i = e.className, n = e.icon, h = e.spin, c = e.rotate, s = e.tabIndex, u = e.onClick, m = e.twoToneColor, f = zt(e, wi), p = a.useContext(Ut), d = p.prefixCls, l = d === void 0 ? "anticon" : d, w = p.rootClassName, C = hn(w, l, Et(Et({}, "".concat(l, "-").concat(n.name), !!n.name), "".concat(l, "-spin"), !!h || n.name === "loading"), i), x = s;
  x === void 0 && u && (x = -1);
  var E = c ? {
    msTransform: "rotate(".concat(c, "deg)"),
    transform: "rotate(".concat(c, "deg)")
  } : void 0, v = Qt(m), L = jt(v, 2), r = L[0], g = L[1];
  return /* @__PURE__ */ a.createElement("span", ot({
    role: "img",
    "aria-label": n.name
  }, f, {
    ref: o,
    tabIndex: x,
    onClick: u,
    className: C
  }), /* @__PURE__ */ a.createElement(fe, {
    icon: n,
    primaryColor: r,
    secondaryColor: g,
    style: E
  }));
});
Ce.displayName = "AntdIcon";
Ce.getTwoToneColor = ui;
Ce.setTwoToneColor = Xt;
var Ci = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "ellipsis", theme: "outlined" }, xi = function(o, i) {
  return /* @__PURE__ */ a.createElement(Ce, ot({}, o, {
    ref: i,
    icon: Ci
  }));
}, Jt = /* @__PURE__ */ a.forwardRef(xi);
process.env.NODE_ENV !== "production" && (Jt.displayName = "EllipsisOutlined");
var yi = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, name: "left", theme: "outlined" }, vi = function(o, i) {
  return /* @__PURE__ */ a.createElement(Ce, ot({}, o, {
    ref: i,
    icon: yi
  }));
}, Kt = /* @__PURE__ */ a.forwardRef(vi);
process.env.NODE_ENV !== "production" && (Kt.displayName = "LeftOutlined");
const bi = (e, o, i, n) => {
  if (!e)
    return "";
  switch (e) {
    case ye.COLUMN:
      return `${o.get(`configuration-metric-target.${ye.COLUMN}`)} ${i && n ? i + n : ""}`;
    case ye.BAR:
      return `${o.get(`configuration-metric-target.${ye.BAR}`)} ${n && !i ? n : ""}`;
    default:
      return o.get(`configuration-metric-target.${e}`);
  }
}, ki = Z(({
  id: e,
  environmentId: o,
  availableDimensions: i,
  value: n,
  canInvert: h,
  onChange: c,
  viewsWithMetrics: s,
  optionsDisabled: u,
  configuration: m,
  numberOfSlicer: f,
  getPopupContainer: p,
  isAxisOptionDisabled: d = !1,
  displayType: l,
  dashboardSelection: w,
  period: C,
  metaModel: x,
  setActiveKey: E,
  isAxisOptionAvailable: v,
  activeKey: L,
  handleDuplicate: r,
  handlePaste: g,
  onCopy: F,
  copiedMetric: T,
  isOptionsDisplayed: H,
  setIsOptionsDisplayed: B,
  getMoreInformationLink: $,
  loadDictionaryEntries: W,
  loadPeriods: k,
  withPasteOptions: ee,
  withDisplayOptions: Q
}) => {
  var it, rt, lt, st, ct, at, dt, ht;
  const D = q(), I = Je(), N = U(), te = A(() => Xe({
    dashboardSelection: w,
    chartPeriod: C
  }, !0), [w, C]), y = nt(te), R = O((X) => {
    n && c(K(e), {
      ...n,
      ...X
    }), B(!1);
  }, [e, c, B, n]), z = O(() => {
    var X;
    n && !d && c(K(e), {
      ...n,
      extraConf: {
        ...n == null ? void 0 : n.extraConf,
        isDisplayedOnSecondaryAxis: !((X = n == null ? void 0 : n.extraConf) != null && X.isDisplayedOnSecondaryAxis)
      }
    });
  }, [e, d, c, n]), j = A(() => d ? D.get("configuration-chart-cannot-modify-axis") : n != null && n.extraConf && (n != null && n.extraConf.isDisplayedOnSecondaryAxis) ? D.get("configuration-chart-set-to-first-axis") : D.get("configuration-chart-set-to-second-axis"), [d, D, n == null ? void 0 : n.extraConf]), ne = A(() => /* @__PURE__ */ b("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ t("path", { d: "M6 17.8161L9.17284 14.2695M6.8823 16.8299L10.0551 13.2833", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ t("path", { d: "M12.9449 14.2674L16.1177 10.7209M13.8272 13.2812L17 9.73467", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ t("path", { d: "M10.0551 13.2833L12.3161 14.0533M10.6839 13.4974L12.9449 14.2674", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ t(
      "path",
      {
        d: "M20.48 6.36C20.24 6.68 19.76 6.68 19.52 6.36L17.72 3.96C17.4233 3.56446 17.7056 3 18.2 3L21.8 3C22.2944 3 22.5767 3.56446 22.28 3.96L20.48 6.36Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ t("path", { d: "M2 21H16.8661M6.13393 21H21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ t("path", { d: "M20 9L20 21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })
  ] }), []), Pe = A(() => /* @__PURE__ */ b("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ t("path", { d: "M6 17.8161L9.17284 14.2695M6.8823 16.8299L10.0551 13.2833", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ t("path", { d: "M12.9449 14.2674L16.1177 10.7209M13.8272 13.2812L17 9.73467", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ t("path", { d: "M10.0551 13.2833L12.3161 14.0533M10.6839 13.4974L12.9449 14.2674", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ t("path", { d: "M2 21H16.8661M6.13393 21H21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ t(
      "path",
      {
        d: "M3.48 6.36C3.24 6.68 2.76 6.68 2.52 6.36L0.72 3.96C0.423344 3.56446 0.705573 3 1.2 3L4.8 3C5.29443 3 5.57666 3.56446 5.28 3.96L3.48 6.36Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ t("path", { d: "M3 9L3 21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })
  ] }), []), De = n && ((lt = (rt = (it = s.find(({ code: X }) => X === n.viewCode)) == null ? void 0 : it.metrics) == null ? void 0 : rt.find(({ code: X }) => X === n.metricCode)) == null ? void 0 : lt.description), xe = A(
    () => T === void 0 || (T == null ? void 0 : T.additionalFilters.length) === 0 || T != null && T.additionalFilters.every((X) => i.find((eo) => eo.code === X.dimensionCode)) ? 1 : 0,
    [i, T]
  ), G = bt(N, "none", 2), le = bt(N, "auto", 8), de = A(() => n ? /* @__PURE__ */ t(Ni, { environmentId: o, availableDimensions: i, id: e, value: n, configuration: m, onValuesChange: R, getPopupContainer: p, dashboardSelection: w, displayType: l, canInvert: h, dayDifference: y, period: C, activeKey: L, metaModel: x, onCancel: () => {
    B(!1);
  }, loadDictionaryEntries: W, loadPeriods: k, layout: N, withDisplayOptions: Q }) : /* @__PURE__ */ t(ce, {}), [L, i, h, m, w, y, l, o, p, e, N, W, k, x, R, C, B, n, Q]), Mt = A(
    () => N === "default" ? /* @__PURE__ */ t(
      pt,
      {
        trigger: "click",
        open: H,
        destroyTooltipOnHide: !0,
        onOpenChange: (X) => {
          B(X), E(J.filters);
        },
        overlayInnerStyle: {
          backgroundColor: "var(--popup-background)"
        },
        overlayClassName: "metric-options-popup",
        arrow: !1,
        align: {
          points: ["tr", "br"],
          offset: [328, 0],
          targetOffset: [0, 0]
        },
        getPopupContainer: p,
        content: de,
        children: /* @__PURE__ */ t(P, { clickable: !0, children: /* @__PURE__ */ t(ze, {}) })
      }
    ) : /* @__PURE__ */ t(P, { clickable: !0, onClick: () => {
      B(!0), E(J.filters);
    }, children: /* @__PURE__ */ t(ze, {}) }),
    [p, H, N, de, E, B]
  );
  return /* @__PURE__ */ b(ce, { children: [
    /* @__PURE__ */ b(Ei, { children: [
      /* @__PURE__ */ t(Rt, { $value: 5, ...G, children: De && N !== "compact" && /* @__PURE__ */ t(Mn, { metric: n, timeInterval: te, getMoreInformationLink: $ }) }),
      !u && /* @__PURE__ */ b(ce, { children: [
        /* @__PURE__ */ t(Ft, { ...G, title: D.get("configuration-metric-options.info.options"), children: n ? Mt : /* @__PURE__ */ t(ce, {}) }),
        ee && /* @__PURE__ */ t(Ft, { ...G, title: D.get("configuration-metric-options.info.paste/duplicate"), children: /* @__PURE__ */ t(Co, { handleDuplicate: r, onCopy: F }) }),
        ee && /* @__PURE__ */ t(he, { $value: 5, ...G, title: D.get("configuration-metric-options.info.more"), children: /* @__PURE__ */ t(
          pt,
          {
            trigger: "click",
            placement: "rightTop",
            overlayClassName: "paste-options",
            content: /* @__PURE__ */ b(Li, { children: [
              /* @__PURE__ */ b(pe, { onClick: () => {
                I.capture({
                  category: "metric-options",
                  action: "paste-options"
                }), g(["decimals", "details", "units", "color", "overridePeriod", "overridePeriodLabel", "additionalFilters", "additionalFiltersLabel", "growthType", "growthPeriod", "growthInvert", "growthLabel"]);
              }, children: [
                /* @__PURE__ */ t(P, { clickable: !0, children: /* @__PURE__ */ t(ze, {}) }),
                D.get("configuration-metric-options.paste.metric-options")
              ] }),
              /* @__PURE__ */ b(pe, { $margin: 8, $enabled: xe, onClick: () => {
                I.capture({
                  category: "metric-options",
                  action: "paste-filters"
                }), g(["additionalFilters", "additionalFiltersLabel"]);
              }, children: [
                /* @__PURE__ */ t(P, { size: 12, color: "var(--medium-grey)", children: /* @__PURE__ */ t(ve, {}) }),
                /* @__PURE__ */ t(P, { clickable: xe === 1, children: /* @__PURE__ */ t(Vn, {}) }),
                D.get("configuration-metric-options.paste.filters")
              ] }),
              /* @__PURE__ */ b(pe, { $margin: 8, onClick: () => {
                I.capture({
                  category: "metric-options",
                  action: "paste-period"
                }), g(["overridePeriod", "overridePeriodLabel"]);
              }, children: [
                /* @__PURE__ */ t(P, { size: 12, color: "var(--medium-grey)", children: /* @__PURE__ */ t(ve, {}) }),
                /* @__PURE__ */ t(P, { clickable: !0, children: /* @__PURE__ */ t(Bt, {}) }),
                D.get("configuration-metric-options.paste.period")
              ] }),
              /* @__PURE__ */ b(pe, { $margin: 8, $enabled: (st = n == null ? void 0 : n.metricDef) != null && st.asRatio ? 0 : 1, onClick: () => {
                I.capture({
                  category: "metric-options",
                  action: "paste-growth"
                }), g(["growthType", "growthPeriod", "growthInvert", "growthLabel"]);
              }, children: [
                /* @__PURE__ */ t(P, { size: 12, color: "var(--medium-grey)", children: /* @__PURE__ */ t(ve, {}) }),
                /* @__PURE__ */ t(P, { clickable: !0, children: /* @__PURE__ */ t(It, {}) }),
                D.get("configuration-metric-options.paste.growth")
              ] }),
              /* @__PURE__ */ b(pe, { $margin: 8, onClick: () => {
                I.capture({
                  category: "metric-options",
                  action: "paste-display"
                }), g([
                  "color",
                  "decimals",
                  "details",
                  ...n && Dt(n) ? ["units"] : []
                ]);
              }, children: [
                /* @__PURE__ */ t(P, { size: 12, color: "var(--medium-grey)", children: /* @__PURE__ */ t(ve, {}) }),
                /* @__PURE__ */ t(P, { clickable: !0, children: /* @__PURE__ */ t(Wt, {}) }),
                D.get("configuration-metric-options.paste.display")
              ] })
            ] }),
            children: /* @__PURE__ */ t(P, { clickable: !0, children: /* @__PURE__ */ t(Jt, {}) })
          }
        ) })
      ] }),
      v && /* @__PURE__ */ t(Rt, { $value: 7, ...G, children: /* @__PURE__ */ t(
        Qe,
        {
          size: "small",
          mouseEnterDelay: 0.5,
          content: j,
          children: /* @__PURE__ */ t($i, { $defaultvalue: (ct = n == null ? void 0 : n.extraConfDefaultProperties) != null && ct.isDisplayedOnSecondaryAxis ? 1 : 0, children: /* @__PURE__ */ t(
            P,
            {
              onClick: z,
              disable: d,
              color: ((at = n == null ? void 0 : n.extraConfDefaultProperties) == null ? void 0 : at.isDisplayedOnSecondaryAxis) === !1 || (dt = n == null ? void 0 : n.extraConf) != null && dt.isDisplayedOnSecondaryAxis ? "var(--primary)" : void 0,
              clickable: !0,
              children: (ht = n == null ? void 0 : n.extraConf) != null && ht.isDisplayedOnSecondaryAxis ? ne : Pe
            }
          ) })
        }
      ) }),
      /* @__PURE__ */ t(he, { $value: 5, ...le, children: /* @__PURE__ */ t(Si, { children: m != null && m.metricTarget ? bi(m.metricTarget[K(e)], D, f, e) : "" }) })
    ] }),
    N === "compact" && /* @__PURE__ */ t(io, { open: H, onClose: () => B(!1), width: 700, closeIcon: /* @__PURE__ */ t(Kt, {}), children: de })
  ] });
}), Ei = S(oe)`
`, Li = S.div`
    display: flex;
    flex-direction: column;
    padding: 4px 10px;
`, pe = S.div`
    text-align: center;
    flex-basis: 100%;
    display: flex;
    gap: 10px;
    flex-direction: row;
    align-items: center;
    ${({ $margin: e }) => e ? `margin-left: ${e}px;` : ""}
    ${({ $enabled: e }) => e === void 0 || e === 1 ? `
    &:hover {
        cursor: pointer;
        color: var(--primary);
    }
    ` : `
    opacity: 0.2;
    * {
      cursor: unset;
    }
    `}



`, $i = S.div`
    margin-right: 5px;
    margin-left: 5px;
    padding-bottom: 3px;

    * {
        ${({ $defaultvalue: e }) => e ? "opacity: 0.85;" : ""}
    }
`, Si = S.div`
    color: var(--light-grey);
    height: 100%;
    display: flex;
    align-items: center;
`, Rt = S(he)`
    align-content: center;
    align-items: center;
    display: flex;
    justify-content: center;
`, Ft = S(V)`
    display: flex;
    align-items: center;

    &:hover {
        color: var(--primary);
    }`, At = Z(function({
  id: o,
  environmentId: i,
  value: n,
  canInvert: h,
  canRemove: c,
  onChange: s,
  handleAdd: u,
  onDelete: m,
  groupMetricsByView: f,
  viewsWithMetrics: p,
  unavailableViews: d,
  optionsDisabled: l,
  configuration: w,
  numberOfSlicer: C,
  getPopupContainer: x,
  isAxisOptionAvailable: E = !1,
  displayType: v,
  dashboardSelection: L,
  period: r,
  metaModel: g,
  datamodel: F,
  onCopy: T,
  copiedMetric: H,
  getMoreInformationLink: B,
  loadDictionaryEntries: $,
  loadPeriods: W,
  withPasteOptions: k,
  withDisplayOptions: ee
}) {
  const [Q, D] = Le(!1), I = q(), N = U(), te = we(), y = A(() => Vo(g, F, n != null && n.viewCode ? [n.viewCode] : []), [g, n == null ? void 0 : n.viewCode]), R = A(() => Xe({
    dashboardSelection: L,
    chartPeriod: r
  }, !0), [L, r]), z = nt(R), j = O(() => {
    n && u(n);
  }, [u, n]), ne = O((G) => {
    if (H || ro.info({
      duration: 2.5,
      key: "copied-metric-fail",
      message: I.get("configuration-metric-options.metric-copy-fail"),
      description: I.get("configuration-metric-options.metric-copy-fail-description"),
      placement: "bottomRight"
    }), n && H) {
      const le = Ee(n, y);
      s(K(o), G.length > 0 ? Ge(qe({
        ...le,
        ...M.pick(Ee(H, y), G)
      }, le)) : H);
    }
  }, [y, H, o, I, s, n]), Pe = O((G) => {
    n && s(K(o), Ge(qe(G.reduce((le, de) => ({
      ...le,
      [de]: M.isArray(le[de]) ? [] : void 0
    }), Ee(n, y)), n)));
  }, [y, o, s, n]), De = ae(N, { span: 13 }, { span: 22 }), xe = ae(N, { span: 10 }, { span: 1 });
  return /* @__PURE__ */ b(ce, { children: [
    /* @__PURE__ */ t(V, { ...De, children: /* @__PURE__ */ t(
      Se,
      {
        environmentId: i,
        id: o,
        value: n,
        groupMetricsByView: f,
        viewsWithMetrics: p,
        unavailableViews: d,
        canInvert: h,
        canRemove: c,
        onChange: s,
        onDelete: m,
        configuration: w,
        numberOfSlicer: C,
        getPopupContainer: x,
        isAxisOptionAvailable: E,
        isAxisOptionDisabled: o === 1,
        metaModel: g,
        dashboardSelection: L,
        period: r,
        timeInterval: R,
        getMoreInformationLink: B
      }
    ) }),
    /* @__PURE__ */ t(V, { ...xe, children: /* @__PURE__ */ t(ki, { environmentId: i, availableDimensions: y, id: o, value: n, groupMetricsByView: f, viewsWithMetrics: p, unavailableViews: d, optionsDisabled: l, canInvert: h, canRemove: c, onChange: s, onDelete: m, configuration: w, numberOfSlicer: C, getPopupContainer: x, isAxisOptionAvailable: E, isAxisOptionDisabled: o === 1, displayType: v, metaModel: g, dashboardSelection: L, period: r, setActiveKey: (G) => {
      te.current = G;
    }, activeKey: te.current, handleDuplicate: j, handlePaste: ne, copiedMetric: H, onCopy: T, isOptionsDisplayed: Q, setIsOptionsDisplayed: D, getMoreInformationLink: B, loadDictionaryEntries: $, loadPeriods: W, layout: N, withPasteOptions: k, withDisplayOptions: ee }) }),
    /* @__PURE__ */ t(
      Gt,
      {
        iconSize: 14,
        value: n,
        additionnalStyle: "width: 65%; margin-left: 3%;",
        isNameDisplayed: !0,
        timeInterval: R,
        dayDifference: z,
        setActiveKey: (G) => {
          D(G !== void 0), te.current = G;
        },
        onDelete: Pe
      }
    )
  ] });
});
S(oe)`
    align-items: center
`;
const gl = Z(({
  environmentId: e,
  value: o = [],
  onChange: i,
  viewsWithMetrics: n,
  unavailableViews: h,
  groupMetricsByView: c = !1,
  optionsDisabled: s = !1,
  multiple: u = !1,
  invertible: m = !1,
  getPopupContainer: f,
  configuration: p,
  numberOfSlicer: d,
  metaModel: l,
  datamodel: w,
  displayType: C,
  format: x,
  dashboardSelection: E,
  period: v,
  onCopy: L,
  copiedMetric: r,
  getMoreInformationLink: g,
  loadDictionaryEntries: F,
  loadPeriods: T,
  withPasteOptions: H = !0,
  withDisplayOptions: B = !0
}) => {
  const $ = q(), W = Go(C, x), k = A(
    () => {
      const y = o.filter((R, z) => u || z === 0).filter((R) => {
        var z;
        return (z = n.find(({ code: j }) => j === R.viewCode)) == null ? void 0 : z.metrics.find(({ code: j }) => j === R.metricCode);
      });
      return M.isEqual(y, o) ? o : y;
    },
    [o, u, n]
  );
  Nt(i, o, k), ue(() => {
    var y, R;
    k && k.length > 0 && ((R = (y = k[0]) == null ? void 0 : y.extraConf) != null && R.isDisplayedOnSecondaryAxis) && (i == null || i([{
      ...k[0],
      extraConf: {
        ...k[0].extraConf,
        isDisplayedOnSecondaryAxis: !1
      }
    }, ...k.slice(1)]));
  }, [i, k]);
  const ee = O(
    (y) => {
      i == null || i(k.slice(0, y).concat(k.slice(y + 1)));
    },
    [k, i]
  ), Q = qo(), D = Uo(), I = O(
    (y, R) => {
      const z = xt(l, R), j = R && z ? Ye({ ...R, metricDef: z }, $) : void 0, ne = R && n && j ? Ue(n, {
        metricCode: `${R.metricCode}`,
        metricAlias: j,
        viewCode: R.viewCode
      }, c) : void 0;
      i == null || i(k.slice(0, y).concat([{
        ...R,
        ...D(y, R, k, l),
        metricAlias: ne ?? "",
        metricDef: z
      }], k.slice(y + 1)));
    },
    [c, $, l, D, i, k, n]
  ), N = O(
    (y) => {
      const R = xt(l, y), z = y && R ? Ye({ ...y, metricDef: R }, $) : void 0, j = y && n && z ? Ue(n, {
        metricCode: `${y.metricCode}`,
        metricAlias: z,
        viewCode: y.viewCode
      }, c) : void 0;
      i == null || i([...k, {
        ...y,
        ...Q(k.length, y, k, l),
        metricAlias: j ?? "",
        metricDef: R
      }]);
    },
    [l, $, n, c, i, k, Q]
  ), te = A(() => k.length > 1 && C && W, [C, W, k.length]);
  return /* @__PURE__ */ b("div", { children: [
    /* @__PURE__ */ t(
      Tt,
      {
        value: k,
        handleChange: i,
        overlayRender: (y) => /* @__PURE__ */ t(Ot, { activeId: y, children: /* @__PURE__ */ t(At, { environmentId: e, id: y, value: k[K(y)], groupMetricsByView: c, viewsWithMetrics: n, unavailableViews: h, optionsDisabled: s, canInvert: m, canRemove: u, onChange: I, onDelete: ee, configuration: p, numberOfSlicer: d, getPopupContainer: f, displayType: C, metaModel: l, datamodel: w, dashboardSelection: E, period: v, copiedMetric: r, handleAdd: N, onCopy: () => L == null ? void 0 : L(k[K(y)]), getMoreInformationLink: g, loadDictionaryEntries: F, loadPeriods: T, withPasteOptions: H, withDisplayOptions: B }) }),
        children: k.map((y, R) => {
          var z, j;
          return /* @__PURE__ */ t(
            Pt,
            {
              id: me(R),
              containerStyle: { marginBottom: 5 },
              children: /* @__PURE__ */ t(At, { environmentId: e, id: me(R), value: y, groupMetricsByView: c, viewsWithMetrics: n, unavailableViews: h, optionsDisabled: s, canInvert: m, canRemove: u, onChange: I, onDelete: ee, handleAdd: N, configuration: p, numberOfSlicer: d, getPopupContainer: f, isAxisOptionAvailable: te, isAxisOptionDisabled: R === 0, displayType: C, metaModel: l, datamodel: w, dashboardSelection: E, period: v, copiedMetric: r, onCopy: () => L == null ? void 0 : L(y), getMoreInformationLink: g, loadDictionaryEntries: F, loadPeriods: T, withPasteOptions: H, withDisplayOptions: B })
            },
            `${y.metricCode}-${(z = y.growth) == null ? void 0 : z.period}-${(j = y.growth) == null ? void 0 : j.type}-${R}`
          );
        })
      }
    ),
    /* @__PURE__ */ t(oe, { children: (u || k.length === 0) && /* @__PURE__ */ t(li, { offset: 1, environmentId: e, id: k.length, value: void 0, defaultView: k.length > 0 ? k[k.length - 1].viewCode : void 0, groupMetricsByView: c, viewsWithMetrics: n, unavailableViews: h, canInvert: m, canRemove: !1, handleAdd: N, getPopupContainer: f, displayType: C, metaModel: l, dashboardSelection: E, period: v, copiedMetric: r, withPasteOptions: H }) })
  ] });
}), _ = ({
  name: e,
  title: o,
  activated: i = !0,
  initialValue: n,
  additionalComponent: h,
  textAlignment: c = "center",
  contentSpan: s,
  textSpan: u,
  contentMargin: m = 0,
  rules: f,
  children: p
}) => {
  const d = A(() => f != null && f.find((x) => typeof x == "object" ? x.required : !1) ? 1 : 0, [f]), l = U(), w = A(() => s ?? (l === "compact" ? 24 : 17), [s, l]), C = A(() => u ?? (l === "compact" ? 24 : 7), [l, u]);
  return /* @__PURE__ */ b(Ri, { $activated: i ? 1 : 0, children: [
    /* @__PURE__ */ t(Fi, { span: C, $textalignment: c, $required: d, children: o }),
    /* @__PURE__ */ t(Ai, { span: w, $margin: m, children: /* @__PURE__ */ t(xo, { name: e, initialValue: n, rules: f, children: p }) }),
    h
  ] });
}, Ri = S(oe)`
    ${({ $activated: e }) => e ? "" : "color: var(--medium-grey);"}
`, Fi = S(V)`
    display: flex;
    align-items: ${({ $textalignment: e }) => e};
    height: 40px;

    ${({ $required: e }) => e ? ` &::before {
        display: inline-block;
        margin-inline-end: 4px;
        color: #ff4d4f;
        font-size: 14px;
        font-family: SimSun, sans-serif;
        line-height: 1;
        content: "*";
    }` : ""}
`, Ai = S(V)`
    display: flex;
    align-items: center;
    margin: ${({ $margin: e }) => e}px;
`, Ti = Z(({
  availableDimensions: e,
  environmentId: o,
  temporaryMetric: i,
  onMetricChange: n,
  loadDictionaryEntries: h,
  withDisplayOptions: c
}) => {
  const s = q(), u = U(), [m] = re.useForm(), f = Oe(i, []), p = we(null), d = A(() => i.additionalFilters.map((l) => `${l.reference.alias}: ${No(l, s)}`).join(", "), [s, i.additionalFilters]);
  return /* @__PURE__ */ t(re, { form: m, fields: f, onValuesChange: (l) => {
    n({
      ...l,
      ...Object.keys(l)[0] === "additionalFilters" && l.additionalFilters.length === 0 ? {
        additionalFiltersLabel: void 0
      } : {}
    });
  }, children: /* @__PURE__ */ t(Ae, { ref: p, $layout: u, children: /* @__PURE__ */ b(Te, { $layout: u, children: [
    /* @__PURE__ */ t(
      _,
      {
        name: "additionalFilters",
        title: s.get("configuration-label-filters"),
        textAlignment: "center",
        children: /* @__PURE__ */ t(So, { availableDimensions: e, environmentId: o, GACategory: "metric-options", span: 24, loadDictionaryEntries: h, isEditable: !0 })
      }
    ),
    c && /* @__PURE__ */ t(
      _,
      {
        name: "additionalFiltersLabel",
        title: s.get("configuration-metric-options.custom-display"),
        textAlignment: "center",
        children: /* @__PURE__ */ t(tt, { defaultLabel: d })
      }
    )
  ] }) }) });
});
var Oi = /* @__PURE__ */ ((e) => (e.K = "K", e.M = "M", e))(Oi || {});
const Pi = Z(({
  environmentId: e,
  temporaryMetric: o,
  onMetricChange: i,
  loadPeriods: n,
  withDisplayOptions: h
}) => {
  const c = q(), s = U(), [u] = re.useForm(), m = Oe(o, []), f = we(null), p = A(() => o.overridePeriod ? c.getTranslatedName(o.overridePeriod) : "", [c, o.overridePeriod]);
  return /* @__PURE__ */ t(re, { form: u, fields: m, onValuesChange: (d) => {
    i({
      ...d,
      ...Object.keys(d)[0] === "overridePeriod" && M.isEmpty(d.overridePeriod) ? {
        overridePeriodLabel: void 0
      } : {}
    });
  }, children: /* @__PURE__ */ t(Ae, { ref: f, $layout: s, children: /* @__PURE__ */ b(Te, { $layout: s, children: [
    /* @__PURE__ */ t(
      _,
      {
        name: "overridePeriod",
        title: c.get("configuration-metric-options.period.title"),
        children: /* @__PURE__ */ t(
          To,
          {
            name: "overridePeriod",
            environmentId: e,
            overrideOptionLabel: c.get("configuration-metric-options.period.override-option-label"),
            span: 24,
            forTarget: !1,
            withDateSlicerGranularity: !1,
            withOverrideOption: !0,
            GACategory: "metric-options",
            loadPeriods: n
          }
        )
      }
    ),
    h && /* @__PURE__ */ t(
      _,
      {
        name: "overridePeriodLabel",
        title: c.get("configuration-metric-options.custom-display"),
        textAlignment: "center",
        children: /* @__PURE__ */ t(tt, { defaultLabel: p })
      }
    )
  ] }) }) });
}), Di = Z(({
  id: e,
  temporaryMetric: o,
  configuration: i,
  onMetricChange: n,
  displayType: h,
  dayDifference: c,
  canInvert: s,
  dashboardSelection: u,
  period: m,
  withDisplayOptions: f
}) => {
  const p = q(), d = U(), [l] = re.useForm(), w = Oe(o, []), C = we(null), x = Yo(h), E = A(() => o != null && o.growthType && o.growthPeriod ? Qo(
    {
      growth: {
        type: o.growthType,
        period: o.growthPeriod
      },
      titlePartOverrides: o.titlePartOverrides
    },
    p
  ) : void 0, [p, o == null ? void 0 : o.growthPeriod, o == null ? void 0 : o.growthType, o == null ? void 0 : o.titlePartOverrides]);
  return /* @__PURE__ */ t(re, { form: l, fields: w, onValuesChange: (v) => {
    Object.keys(v)[0] === "activated" ? v.activated ? n({
      growthPeriod: {
        unit: se.WEEK,
        quantity: 1
      },
      growthType: x,
      activated: !0
    }) : n({
      growthType: void 0,
      growthPeriod: void 0,
      activated: !1,
      growthLabel: void 0
    }) : Object.keys(v)[0] === "growthPeriod" ? n({
      growthType: (o == null ? void 0 : o.growthType) ?? He.VALUE,
      growthPeriod: v.growthPeriod ? {
        ...v.growthPeriod,
        quantity: v.growthPeriod.quantity === null ? 1 : v.growthPeriod.quantity
      } : void 0
    }) : Object.keys(v)[0] === "growthType" ? n({
      growthType: v.growthType ?? He.VALUE,
      growthPeriod: (o == null ? void 0 : o.growthPeriod) ?? {
        unit: se.WEEK,
        quantity: 1
      }
    }) : n(v);
  }, children: /* @__PURE__ */ t(Ae, { ref: C, $layout: d, children: /* @__PURE__ */ b(Te, { $layout: d, children: [
    /* @__PURE__ */ t(_, { name: "activated", title: p.get("configuration-metric-options.growth.activated"), children: /* @__PURE__ */ t(Xo, {}) }),
    /* @__PURE__ */ t(
      _,
      {
        name: "growthType",
        title: p.get("configuration-metric-options.growth.type"),
        activated: !!(o != null && o.activated),
        children: /* @__PURE__ */ t(Jo, { configuration: i, activated: !!(o != null && o.activated) })
      }
    ),
    /* @__PURE__ */ t(
      _,
      {
        name: "growthPeriod",
        title: p.get("configuration-metric-options.growth.period"),
        activated: !!(o != null && o.activated) && (o == null ? void 0 : o.growthType) !== void 0,
        additionalComponent: (o == null ? void 0 : o.growthPeriod) && /* @__PURE__ */ t(V, { span: 17, offset: 7, style: {
          marginTop: 10,
          display: "flex",
          alignItems: "center"
        }, children: d !== "compact" && u && /* @__PURE__ */ t(Hi, { children: _t(Zt(
          o.growthPeriod.unit,
          o.growthPeriod.quantity ?? void 0,
          Xe({ dashboardSelection: u, chartPeriod: m }, !0),
          c
        )) }) }),
        children: /* @__PURE__ */ t(
          Ko,
          {
            id: e,
            dayDifference: c,
            period: m,
            dashboardSelection: u,
            activated: !!(o != null && o.activated)
          }
        )
      }
    ),
    s && o && o.growthPeriod && o.growthType !== He.VALUE && /* @__PURE__ */ t(
      _,
      {
        name: "growthInvert",
        title: p.get("configuration-metric-options.growth.options"),
        children: /* @__PURE__ */ t(Mo, {})
      }
    ),
    f && /* @__PURE__ */ t(
      _,
      {
        name: "growthLabel",
        title: p.get("configuration-metric-options.growth.display"),
        activated: !!(o != null && o.activated) && (o == null ? void 0 : o.growthType) !== void 0,
        children: /* @__PURE__ */ t(
          tt,
          {
            activated: !!(o != null && o.activated) && (o == null ? void 0 : o.growthType) !== void 0,
            defaultLabel: E
          }
        )
      }
    )
  ] }) }) });
}), Hi = S.div`
    font-weight: 500;
    font-size: 15px;
    line-height: 22.5px;
    text-align: right;
    color: rgba(0, 0, 0, 0.2);
`;
var Bi = /* @__PURE__ */ ((e) => (e.K = "K", e.M = "M", e))(Bi || {});
const zi = Z(({
  temporaryMetric: e,
  onMetricChange: o,
  configuration: i
}) => {
  var f, p, d;
  const n = q(), h = U(), [c] = re.useForm(), s = Oe(e, []), u = we(null), m = ln(o);
  return /* @__PURE__ */ t(re, { form: c, fields: s, onValuesChange: m, children: /* @__PURE__ */ t(Ae, { ref: u, $layout: h, children: /* @__PURE__ */ b(Te, { $layout: h, children: [
    /* @__PURE__ */ t(
      _,
      {
        name: "decimals",
        title: n.get("configuration-metric-options.display.decimals"),
        contentSpan: 5,
        children: /* @__PURE__ */ t(en, { defaultLabel: ((f = e.metricDef) == null ? void 0 : f.formatPrecision) ?? 0, gaevent: {
          category: "metric-options",
          action: "update-decimals"
        } })
      }
    ),
    M.isEmpty((p = e.metricDef) == null ? void 0 : p.formatPrefix) && M.isEmpty((d = e.metricDef) == null ? void 0 : d.formatSuffix) && /* @__PURE__ */ t(
      _,
      {
        name: "details",
        title: n.get("configuration-metric-options.display.details.title"),
        children: /* @__PURE__ */ t(tn, { gaevent: {
          category: "metric-options",
          action: "update-details"
        } })
      }
    ),
    Dt(e) && /* @__PURE__ */ t(
      _,
      {
        name: "units",
        title: n.get("configuration-metric-options.display.units.title"),
        contentSpan: 8,
        children: /* @__PURE__ */ t(ut, { gaevent: {
          category: "metric-options",
          action: "update-units"
        }, dropdownMatchSelectWidth: !1, options: [{
          value: null,
          label: /* @__PURE__ */ b(We, { children: [
            /* @__PURE__ */ t(Ne, { children: /* @__PURE__ */ t(Hn, {}) }),
            /* @__PURE__ */ t(Ze, { children: "-" }),
            /* @__PURE__ */ t(_e, { children: n.get("configuration-metric-options.display.units.options.units") })
          ] })
        }, {
          value: "K",
          label: /* @__PURE__ */ b(We, { children: [
            /* @__PURE__ */ t(Ne, { children: "k" }),
            /* @__PURE__ */ t(Ze, { children: "-" }),
            /* @__PURE__ */ t(_e, { children: n.get("configuration-metric-options.display.units.options.k") })
          ] })
        }, {
          value: "M",
          label: /* @__PURE__ */ b(We, { children: [
            /* @__PURE__ */ t(Ne, { children: "M" }),
            /* @__PURE__ */ t(Ze, { children: "-" }),
            /* @__PURE__ */ t(_e, { children: n.get("configuration-metric-options.display.units.options.m") })
          ] })
        }] })
      }
    ),
    /* @__PURE__ */ b(oe, { children: [
      /* @__PURE__ */ t(V, { span: 14, children: /* @__PURE__ */ t(
        _,
        {
          name: "type",
          title: n.get("configuration-metric-options.display.type.title"),
          textSpan: 12,
          contentSpan: 12,
          initialValue: null,
          children: /* @__PURE__ */ t(ut, { gaevent: {
            category: "metric-options",
            action: "update-type"
          }, options: [{
            value: null,
            label: n.get("configuration-metric-options.display.type.options.default")
          }, {
            value: Y.fixed,
            label: n.get(`configuration-metric-options.display.type.options.${Y.fixed}`)
          }, {
            value: Y.interval,
            label: n.get(`configuration-metric-options.display.type.options.${Y.interval}`)
          }, {
            value: Y.gradient,
            label: n.get(`configuration-metric-options.display.type.options.${Y.gradient}`)
          }] })
        }
      ) }),
      !(i != null && i.isColorOverridable) && e.type === Y.fixed && /* @__PURE__ */ t(V, { span: 9, offset: 1, children: /* @__PURE__ */ b(je, { children: [
        /* @__PURE__ */ t(P, { children: /* @__PURE__ */ t(Be, {}) }),
        n.get("configuration-metric-options.display.color-warning")
      ] }) }),
      !(i != null && i.isGradiantAvailable) && e.type === Y.gradient && /* @__PURE__ */ t(V, { span: 9, offset: 1, children: /* @__PURE__ */ b(je, { children: [
        /* @__PURE__ */ t(P, { children: /* @__PURE__ */ t(Be, {}) }),
        n.get("configuration-metric-options.display.color-warning-gradient")
      ] }) }),
      !(i != null && i.isIntervalAvailable) && e.type === Y.interval && /* @__PURE__ */ t(V, { span: 9, offset: 1, children: /* @__PURE__ */ b(je, { children: [
        /* @__PURE__ */ t(P, { children: /* @__PURE__ */ t(Be, {}) }),
        n.get("configuration-metric-options.display.color-warning-interval")
      ] }) })
    ] }),
    e.type === Y.interval && /* @__PURE__ */ t(
      _,
      {
        name: Y.interval,
        title: "",
        children: /* @__PURE__ */ t(on, {})
      }
    ),
    e.type === Y.fixed && /* @__PURE__ */ t(
      _,
      {
        name: "color",
        title: "",
        initialValue: null,
        contentSpan: 8,
        children: /* @__PURE__ */ t(nn, {})
      }
    ),
    e.type === Y.gradient && /* @__PURE__ */ t(
      _,
      {
        name: Y.gradient,
        title: "",
        contentSpan: 16,
        children: /* @__PURE__ */ t(rn, {})
      }
    )
  ] }) }) });
}), je = S.div`
    display: flex;
    justify-content: end;
    text-align: left;
    font-size: 0.7em;
    line-height: 1em;
    color: var(--light-text);
    align-items: center;
    gap: 8px;
    height: 100%;
`, Ne = S.span`
    min-width: 20px;
`, Ze = S.span`
    min-width: 15px;
`, _e = S.span`
    font-style: italic;
`, We = S.div`
    display: flex;
`, ji = Z(({
  id: e,
  availableDimensions: o,
  environmentId: i,
  value: n,
  configuration: h,
  onValuesChange: c,
  dashboardSelection: s,
  displayType: u,
  canInvert: m,
  dayDifference: f,
  period: p,
  onCancel: d,
  activeKey: l,
  metaModel: w,
  loadDictionaryEntries: C,
  loadPeriods: x,
  withDisplayOptions: E
}) => {
  var R, z;
  const v = q(), L = U(), [r, g] = Le(Ee(n, o)), F = Ke({
    growth: r && r.growthType && r.growthPeriod ? {
      type: r.growthType,
      period: r.growthPeriod
    } : void 0
  }), T = Me({ additionalFilters: (r == null ? void 0 : r.additionalFilters) ?? [] }), H = et({ overridePeriod: r == null ? void 0 : r.overridePeriod }), B = Ht({
    extraConf: {
      details: M.isEqual(r.details, (R = n.extraConf) == null ? void 0 : R.details) ? r.details : void 0,
      units: r.units ?? void 0,
      decimals: M.isEqual(r.decimals, (z = n.extraConf) == null ? void 0 : z.decimals) ? r.decimals : void 0,
      color: r.color ?? void 0
    }
  }), $ = O((j) => {
    const ne = {
      ...r,
      ...j
    };
    g({
      ...ne,
      additionalFilters: Lo(ne.additionalFilters, o)
    });
  }, [o, r]), W = O(() => {
    r && c(Ge(qe(r, n)));
  }, [c, r, n]), k = O(() => {
    n && g((j) => ({
      ...j,
      growthType: void 0,
      growthPeriod: void 0,
      activated: !1,
      additionalFilters: [],
      color: null,
      units: null,
      overridePeriod: void 0,
      overridePeriodLabel: void 0,
      additionalFiltersLabel: void 0,
      growthLabel: void 0,
      label: void 0
    }));
  }, [n]), ee = A(() => Ye(r, v), [v, r]);
  ue(() => {
    D(l);
  }, [l]);
  const [Q, D] = Le(l), I = A(() => /* @__PURE__ */ t(Ti, { environmentId: i, availableDimensions: o, temporaryMetric: r, onMetricChange: $, loadDictionaryEntries: C, withDisplayOptions: E, layout: L }), [o, i, L, C, $, r, E]), N = A(() => /* @__PURE__ */ t(Pi, { environmentId: i, temporaryMetric: r, onMetricChange: $, metaModel: w, loadPeriods: x, withDisplayOptions: E }), [i, x, w, $, r, E]), te = A(() => /* @__PURE__ */ t(Di, { id: e, temporaryMetric: r, configuration: h, onMetricChange: $, dashboardSelection: s, displayType: u, canInvert: m, dayDifference: f, period: p, withDisplayOptions: E }), [m, h, s, f, u, e, $, p, r, E]), y = A(() => /* @__PURE__ */ t(zi, { environmentId: i, configuration: h, temporaryMetric: r, onMetricChange: $, metaModel: w }), [h, i, w, $, r]);
  return /* @__PURE__ */ b("div", { children: [
    /* @__PURE__ */ b(Zi, { "data-testid": "title", children: [
      ee,
      L === "default" && /* @__PURE__ */ t(P, { clickable: !0, onClick: d, children: /* @__PURE__ */ t(Zn, {}) })
    ] }),
    L === "default" ? /* @__PURE__ */ t(
      _i,
      {
        tabPosition: L === "default" ? "left" : "top",
        activeKey: Q,
        onChange: (j) => D == null ? void 0 : D(j),
        items: [{
          active: Q === J.filters,
          key: J.filters,
          label: /* @__PURE__ */ b(be, { $modified: T ? 1 : 0, children: [
            /* @__PURE__ */ t(P, { size: 22, children: /* @__PURE__ */ t(Do, {}) }),
            v.get("configuration-metric-options.filters.title")
          ] }),
          children: I
        }, {
          active: Q === J.period,
          key: J.period,
          label: /* @__PURE__ */ b(be, { $modified: H ? 1 : 0, children: [
            /* @__PURE__ */ t(P, { size: 22, children: /* @__PURE__ */ t(Ho, {}) }),
            v.get("configuration-metric-options.period.title")
          ] }),
          children: N
        }, {
          active: Q === J.growth,
          key: J.growth,
          label: /* @__PURE__ */ b(be, { $modified: F ? 1 : 0, children: [
            /* @__PURE__ */ t(P, { size: 22, children: /* @__PURE__ */ t(Bo, {}) }),
            v.get("configuration-metric-options.growth.title")
          ] }),
          children: te
        }].concat(E ? [{
          active: Q === J.display,
          key: J.display,
          label: /* @__PURE__ */ b(be, { $modified: B ? 1 : 0, children: [
            /* @__PURE__ */ t(P, { size: 22, children: /* @__PURE__ */ t(zo, {}) }),
            v.get("configuration-metric-options.display.title")
          ] }),
          children: y
        }] : [])
      }
    ) : /* @__PURE__ */ t(
      lo,
      {
        size: "small",
        bordered: !1,
        items: [{
          key: "dimensionFilters",
          label: /* @__PURE__ */ t(Wi, {}),
          children: I
        }, {
          key: "period",
          label: /* @__PURE__ */ t(Ii, {}),
          children: N
        }, {
          key: "growth",
          label: /* @__PURE__ */ t(Gi, {}),
          children: te
        }].concat(E ? [{
          key: "display",
          label: /* @__PURE__ */ t(qi, {}),
          children: y
        }] : [])
      }
    ),
    /* @__PURE__ */ t(
      sn,
      {
        onReset: k,
        onSave: W,
        onCancel: d
      }
    )
  ] });
}), Ni = ji, Zi = S.div`
    display: flex;
    font-weight: 600;
    padding: 4px 20px;
    border-bottom: 1px solid var(--main-background-color);
    justify-content: space-between;
    align-items: center;
`, be = S.div`
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
    gap: 13px;
    ${({ $modified: e }) => e ? "color: var(--primary);" : ""}
`, _i = S(so)`
    .ant-tabs-content {
        display: flex;
        flex-direction: column;
    }

    .ant-tabs-content {
        height: 100%;
        display: flex;
        justify-content: space-between;
    }

    .ant-tabs-tab-active {
        background-color: #D9DFFC;
    }

    &&& .ant-tabs-nav-wrap {
        padding-right: 10px !important;
    }

    .ant-tabs-tab {
        padding: 4px 8px;
        margin: 0 0 0 0;
    }
`, Wi = () => /* @__PURE__ */ t(Fe, { icon: Zo, label: "configuration-label-filters", display: "block", layout: "flex" }), Ii = () => /* @__PURE__ */ t(
  Fe,
  {
    icon: Bt,
    label: "configuration-label-period",
    display: "block",
    layout: "flex"
  }
), Gi = () => /* @__PURE__ */ t(
  Fe,
  {
    icon: It,
    label: "configuration-metric-options.growth.title",
    display: "block",
    layout: "flex"
  }
), qi = () => /* @__PURE__ */ t(
  Fe,
  {
    icon: Wt,
    label: "configuration-metric-options.display.title",
    display: "block",
    layout: "flex"
  }
), Ie = Z(function({
  id: o,
  offset: i,
  value: n,
  disabled: h,
  availableDimensions: c,
  canRemove: s,
  onSelect: u,
  onDelete: m,
  options: f,
  getPopupContainer: p,
  configuration: d,
  isDefault: l,
  getMoreInformationLink: w
}) {
  const C = q(), x = U(), E = O(
    ($) => {
      $ || m == null || m(K(o));
    },
    [o, m]
  ), v = O(($, W) => {
    if (!d || wt($) || d.slicerTargets === void 0)
      return "";
    const k = $ == null ? void 0 : $[W < d.slicerTargets.length ? W : d.slicerTargets.length - 1];
    switch (k) {
      case yt.COLUMN:
        return `${C.get(`configuration-slicer-target.${yt.COLUMN}`)} ${W + 1}`;
      default:
        return wt(k) ? "" : C.get(`configuration-slicer-target.${k}`);
    }
  }, [d, C]), L = `${C.get("configuration-add-slicer")} ...`, r = A(() => c.find(($) => $.code === n), [c, n]), g = ae(x, {
    span: 13
  }, {
    span: 22
  }), F = ae(x, {
    span: 1
  }, { span: 0 }), T = ae(x, {}, { span: 0 }), H = A(() => x === "default" ? 5 : 0, [x]), B = /* @__PURE__ */ t(Yi, { value: n ?? null, disabled: h, placeholder: L, showSearch: !0, allowClear: s, optionFilterProp: "children", onChange: E, onSelect: u, virtual: !1, getPopupContainer: p, optionLabelProp: "label", labelRender: ({ label: $ }) => x === "compact" && r ? /* @__PURE__ */ t("div", { children: $ }) : $, children: f.map(($) => /* @__PURE__ */ t(
    Re.Option,
    {
      disabled: $.disabled,
      label: $.selectorLabel,
      children: $.label
    },
    $.value
  )) });
  return /* @__PURE__ */ b(ce, { children: [
    /* @__PURE__ */ t(V, { ...g, offset: i, children: x === "compact" && r ? /* @__PURE__ */ t(
      Qe,
      {
        size: "small",
        mouseEnterDelay: 0.5,
        content: /* @__PURE__ */ t(
          cn,
          {
            dimension: r,
            getMoreInformationLink: w
          }
        ),
        children: B
      }
    ) : B }),
    /* @__PURE__ */ t(Vi, { $value: H, ...F, children: r && x !== "compact" && /* @__PURE__ */ t(Ao, { dimension: r, getMoreInformationLink: w }) }),
    /* @__PURE__ */ t(he, { $value: H, ...T, children: /* @__PURE__ */ t(Ui, { children: d && v(d.slicerTargets, K(o)) }) })
  ] });
}), Ui = S.div`
    color: var(--light-grey);
    height: 100%;
    align-content: center;
`, Yi = S(Re)`
    width: 100%;
`, Vi = S(he)`
    align-content: center;
    align-items: center;
    display: flex;
    justify-content: center;
`, ke = "date_slicer", ul = Z(function({
  value: o = [],
  availableDimensions: i,
  unavailableDimensions: n,
  disabled: h,
  multiple: c = !1,
  onChange: s,
  getPopupContainer: u,
  configuration: m,
  getMoreInformationLink: f
}) {
  const p = q(), d = U(), l = A(
    () => {
      const r = o.filter((g, F) => c || F === 0).filter((g) => {
        switch (g.type) {
          case "dimension":
            return i.find((F) => F.code === g.dimensionCode);
          case "date":
            return !0;
          default:
            return g;
        }
      });
      return r.length === o.length ? o : r;
    },
    [i, o, c]
  );
  Nt(s, o, l);
  const w = O(
    (r) => {
      s == null || s(l.slice(0, r).concat(l.slice(r + 1)));
    },
    [l, s]
  ), C = O(
    (r, g) => {
      g === ke ? s == null || s(l.slice(0, r).concat([{ type: "date", isDefault: !1 }], l.slice(r + 1))) : s == null || s(l.slice(0, r).concat([{ dimensionCode: g, type: "dimension", isDefault: !1 }], l.slice(r + 1)));
    },
    [l, s]
  ), x = O(
    (r) => {
      if (r === ke) {
        const g = l.findIndex((F) => F.type === "date");
        if (g === -1)
          s == null || s([...l, { type: "date", isDefault: !1 }]);
        else {
          const F = Object.assign([], l);
          F[g].isDefault = !1, s == null || s(F);
        }
      } else
        s == null || s([...l, { dimensionCode: r, type: "dimension", isDefault: !1 }]);
    },
    [l, s]
  ), E = O(
    (r, g, F) => {
      const T = l;
      T[g].isDefault = !1, T[F].isDefault = !1, s == null || s(r);
    },
    [s, l]
  ), v = A(
    () => {
      const r = l.find((g) => g.type === "date");
      return [
        {
          label: p.get("date-slicer-option-label"),
          value: ke,
          selectorLabel: `${p.get("date-slicer-option-label")}${r != null && r.isDefault ? ` - ${p.get("by-default")}` : ""}`,
          disabled: r && !r.isDefault
        },
        ...un(i, n).map((g) => ({
          ...g,
          selectorLabel: g.label
        }))
      ];
    },
    [l, p, i, n]
  ), L = O((r) => {
    switch (r.type) {
      case "dimension":
        return r.dimensionCode;
      case "date":
        return ke;
      default:
        return r;
    }
  }, []);
  return /* @__PURE__ */ b("div", { children: [
    /* @__PURE__ */ t(
      Tt,
      {
        value: l,
        handleChange: E,
        overlayRender: (r) => {
          const g = l[K(r)];
          return /* @__PURE__ */ t(Ot, { activeId: r, children: /* @__PURE__ */ t(
            Ie,
            {
              id: r,
              offset: 0,
              value: L(g),
              availableDimensions: i,
              disabled: h,
              options: v,
              canRemove: !0,
              getPopupContainer: u,
              configuration: m,
              isDefault: g.isDefault,
              getMoreInformationLink: f,
              layout: d
            }
          ) });
        },
        children: l == null ? void 0 : l.map(
          (r, g) => /* @__PURE__ */ t(
            Pt,
            {
              id: me(g),
              containerStyle: { marginBottom: 5 },
              children: /* @__PURE__ */ t(
                Ie,
                {
                  id: me(g),
                  offset: 0,
                  value: L(r),
                  availableDimensions: i,
                  disabled: h,
                  options: v,
                  canRemove: !0,
                  onDelete: w,
                  onSelect: (F) => C(g, F),
                  getPopupContainer: u,
                  configuration: m,
                  isDefault: r.isDefault,
                  getMoreInformationLink: f,
                  layout: d
                }
              )
            },
            `${L(r)}-${me(g)}`
          )
        )
      }
    ),
    !h && (c || l.length === 0) && /* @__PURE__ */ t(oe, { children: /* @__PURE__ */ t(Ie, { offset: 1, id: l.length, availableDimensions: i, options: v, canRemove: !1, onSelect: (r) => x(r), getPopupContainer: u, getMoreInformationLink: f, layout: d }) })
  ] });
}), wl = Z(function({
  value: o = [],
  metrics: i,
  viewsWithMetrics: n,
  metaModel: h,
  datamodel: c,
  environmentId: s,
  getPopupContainer: u,
  onChange: m,
  span: f = 14,
  GACategory: p,
  seeDescription: d,
  loadDictionaryEntries: l
}) {
  const w = q(), C = Je(), x = $o(i), E = O(
    (g) => {
      m == null || m(g.map((F) => vo(F)).filter(yo));
    },
    [m]
  );
  ue(() => {
    const g = o.filter((F) => i.find((T) => {
      const H = T && n ? Ue(n, {
        metricCode: T.metricCode,
        metricAlias: T.metricAlias,
        viewCode: T.viewCode
      }, !0) : void 0;
      return F.reference.id === void 0 || H === F.reference.id;
    }));
    (g.length > 0 || o.length > 0) && !M.isEqual(g, o) && E(g);
  }, [E, i, o, n]);
  const v = an(i, c, w), L = O(
    () => v(h, n, x, o),
    [v, x, h, o, n]
  ), r = O((g) => {
    E(g), C.capture({
      category: "charts",
      action: "add_metric_filter"
    });
  }, [C, E]);
  return /* @__PURE__ */ t("div", { className: "filter-selector", children: /* @__PURE__ */ t(oe, { children: /* @__PURE__ */ b(V, { span: f, children: [
    /* @__PURE__ */ t(Qi, { environmentId: s, filters: o, seeDescription: d, layout: "column", onFiltersChange: E, numberOfFilterPerLine: 1, bordered: !0, getPopupContainer: u, GACategory: p, isResumable: !1, isEditable: !0, loadDictionaryEntries: l }),
    /* @__PURE__ */ t(Xi, { children: /* @__PURE__ */ t(bo, { isSimpleInput: !0, filters: o, getPopupContainer: u, getOptions: L, onTemporaryFiltersChange: r, colorized: !0, allowMultipleSelection: !1, getDefaultValue: Ro }) })
  ] }) }) });
}), Qi = S(Fo)`
  margin-bottom: 5px;
`, Xi = S.div`

  &&& .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input) .ant-select-selector {
    background-color: white;
    border-color: var(--border-color-input) !important;
  }
`;
export {
  _ as F,
  Mn as M,
  Se as S,
  qt as T,
  Bi as U,
  _n as a,
  Gt as b,
  zi as c,
  Ti as d,
  Pi as e,
  Ni as f,
  li as g,
  ki as h,
  gl as i,
  oi as j,
  ei as k,
  At as l,
  Ie as m,
  ul as n,
  wl as o,
  Oi as p,
  Di as q
};
//# sourceMappingURL=MetricFilterSelector-BZuPt0Q_.js.map
